import React from 'react';
import { IShipmentOption } from './types';

interface ShipmentSectionHeaderProps {
  option: IShipmentOption;
  reviewText?: string;
}

/**
 * Component for rendering section headers in the shipment dropdown
 * @param option - The section option containing title and counts
 * @param reviewText - Optional review status text to display
 */
export const ShipmentSectionHeader: React.FC<ShipmentSectionHeaderProps> = ({ option, reviewText }) => (
  <div className='flex items-center gap-8 text-neutral-50  w-full'>
    <div className='uppercase text-10'>{option.title}</div>
    <div className='flex items-center gap-8 ml-auto'>
      {reviewText && <div className='text-10 whitespace-nowrap'>{reviewText}</div>}
      <div>
        <div className='rounded-full text-10 bg-neutral-10 text-neutral-80 py-4 px-6 leading-normal whitespace-nowrap min-w-[60px] text-center'>
          {option.itemsTotal && option.itemsCount && (
            <>
              {option.itemsCount} of {option.itemsTotal}
            </>
          )}
        </div>
      </div>
    </div>
  </div>
);
